<ion-header>
  <ion-toolbar>
    <!--ion-buttons slot="start">
    <ion-button color="medium" (click)="cancel()">Cancel</ion-button>
  </ion-buttons-->
    <ion-title>Kalender verwalten</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="confirm()" [strong]="true">Okay</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  @for (calendar of this.state.calendars$ | async; track calendar) {
  <div class="checkbox-container">
    <ion-checkbox
      [(ngModel)]="calendar.active"
      [ngStyle]="{
        '--checkbox-background': calendar.backgroundColorHex,
        '--checkbox-border-color': calendar.backgroundColorHex,
        '--checkbox-background-checked': calendar.backgroundColorHex,
        '--checkbox-checked-color': 'calendar.backgroundColorHex'
      }"
      (ionChange)="onCheckboxChange($event)"
    >
    </ion-checkbox>
    <div class="name">{{ calendar.name }}</div>
  </div>
  }
</ion-content>
